module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ae6356a420075d537e2388245d4ae0c1.png";